import initialState from '../../data/otherUser';
import ActionTypes from '../constants/action-types';

const otherUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_PROFILE:
            return {
                ...state,
                profile: action.payload,
            };

        default: return state;
    }
};

export default otherUserReducer;
